export enum InsertActionTemplateType {
    pbCard = 'PLANNING_BLOCK_CARD' ,
    pbList = 'PLANNING_BLOCK_LIST' , 
    toCard = 'TRANSPORT_ORDER_CARD' , 
    toList = 'TRANSPORT_ORDER_LIST' , 
    planningChart = 'PLANNING_CHART' 
}